import {Cookie} from "js/helper/cookie";

/**
 * И.13435, Н.0000218736: гео-координаты для записи в статистику.
 */
export class Geo {
    static geoCoords() {
        if (navigator.geolocation) {
            let cookie = new Cookie();
            navigator.geolocation.getCurrentPosition(position => {
                let {latitude, longitude} = position.coords;
                cookie.setCookie('geo-coordinates', `${latitude}, ${longitude}`, {'max-age': 2592000});
            }, () => {
                // Нет доступа к позиции.
            });
        }
    }
}
